import {
    Datagrid,
    List,
    ListProps,
    Pagination,
    SelectField,
    TextField,
    useGetIdentity,
} from 'react-admin';
import { dayOrNightChoices } from '../types';

export const WorkReportTemplateList = (props: ListProps) => {
    const { identity } = useGetIdentity();
    return identity ? (
        <List
            {...props}
            bulkActionButtons={false}
            exporter={false}
            pagination={<Pagination rowsPerPageOptions={[]} />}
            perPage={25}
            sort={{ field: 'id', order: 'desc' }}
        >
            <Datagrid rowClick="show">
                <TextField source="id" label="ID" sortable={false} />
                <TextField source="name" label="名前" sortable={false} />
                <SelectField source="dayOrNight" label="昼夜" choices={dayOrNightChoices} sortable={false} />
            </Datagrid>
        </List>
    ) : null;
};
